export var createExport = {

    methods: {
        createExport: function createExport(data, url, filename, extension) {
            axios({
                url: url,
                method: 'POST',
                responseType: 'blob', // important
                data: data
            }).then(function (response) {
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = url;
                filename = filename + ' - ' + localStorage.getItem('property-name');

                if (data.start_date) {
                    filename = filename + ' - ' + moment(data.start_date).format('YYYYMMDD');
                    filename = filename + '-' + moment(data.end_date).format('YYYYMMDD');
                }
                filename = filename + extension;

                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/mixins/createExport.js
// module id = 03pv
// module chunks = 0 1